export const colors = {
    primary:"#FCAD12",
    white:"#FFFFFF",
    black:"#000000",
}